<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card tile>
          <v-card-title>{{
            $t("common." + (edition_mode ? "edit" : "add"))
          }}</v-card-title>
          <v-divider />
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <UserPicker
                required
                v-model="formModel.user"
                :label="$t('user.select-pef')"
              />
              <DatePicker
                required
                v-model="formModel.date"
                :label="$tc('common.date', 1)"
              />
              <FormHelper text="feedback.link_mission.placeholder" />
              <v-textarea
                v-model="formModel.link_mission"
                :label="$t('feedback.link_mission.title')"
                :placeholder="$t('feedback.link_mission.placeholder')"
                required
                :rules="required_rule"
              />
              <FormHelper text="feedback.overall_impression.placeholder" />
              <v-textarea
                v-model="formModel.overall_impression"
                :label="$t('feedback.overall_impression.title')"
                :placeholder="$t('feedback.overall_impression.placeholder')"
                required
                :rules="required_rule"
              />
              <FormHelper text="feedback.detailed_assessment.placeholder" />
              <v-textarea
                v-model="formModel.detailed_assessment"
                :label="$t('feedback.detailed_assessment.title')"
                :placeholder="$t('feedback.detailed_assessment.placeholder')"
                required
                :rules="required_rule"
              />
              <FormHelper text="feedback.recommendation.placeholder" />
              <v-textarea
                v-model="formModel.recommendation"
                :label="$t('feedback.recommendation.title')"
                :placeholder="$t('feedback.recommendation.placeholder')"
                required
                :rules="required_rule"
              />
              <FormHelper text="feedback.follow_instruction.placeholder" />
              <v-textarea
                v-model="formModel.follow_instruction"
                :label="$t('feedback.follow_instruction.title')"
                :placeholder="$t('feedback.follow_instruction.placeholder')"
                required
                :rules="required_rule"
              />
              <p>{{ $t("feedback.visible_by") }}</p>
              <span v-for="(name, value) in get_above_roles()" :key="value">
                <v-checkbox
                  :label="$t('common.role.' + name.toLowerCase())"
                  :value="name"
                  multiple
                  @change="onChangeRole(name)"
                  v-model="formModel.visible_by"
                />
              </span>
            </v-form>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn text @click="$router.go(-1)">{{
              $t("common.cancel")
            }}</v-btn>
            <v-spacer />
            <v-btn tile color="primary" :loading="loading" @click="_submit">{{
              $t("common.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from "@/components/form/DatePicker"
import { ROLES } from "@/utils/config"
import { mapActions } from "vuex"
import { USER_ME_REQUEST } from "@/store/actions/user"
import { ADD, FETCH_ONE, UPDATE } from "@/store/action-types"
import FormMixin from "@/mixins/FormMixin"
import UserPicker from "@/components/form/UserPicker"
import FormHelper from "@/views/feedback/FormHelper"

export default {
  name: "FeedbackForm",
  components: { FormHelper, UserPicker, DatePicker },
  mixins: [FormMixin],
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
  },
  data() {
    return {
      formModel: {
        user: {},
        date: null,
        visible_by: new Set(),
        squad: {},
      },
      link_mission_visible: false,
      valid: true,
    }
  },
  async mounted() {
    if (this.current_user == null) {
      await this.USER_ME_REQUEST()
    }
    if (this.$route.params.feedback_id) {
      this.edition_mode = true
      let self = this
      await this.FETCH_ONE(this.$route.params.feedback_id)
        .then((data) => {
          self.$set(self, "formModel", data)
        })
        .finally(() => {
          self.loading = false
        })
    } else {
      this.formModel.user = { id: Number(this.$route.params.user_id) }
    }
  },

  methods: {
    ...mapActions("user", [USER_ME_REQUEST, UPDATE]),
    ...mapActions("feedback", [FETCH_ONE, UPDATE, ADD]),
    onChangeRole(role) {
      let roles = this.get_above_roles()
      roles.forEach((value) => {
        if (ROLES[role] > ROLES[value]) {
          this.formModel.visible_by.add(value)
        }
      })
    },

    _submit() {
      if (this.formModel.visible_by instanceof Set) {
        this.formModel.visible_by = []
      }
      this.submit(
        [
          "user",
          "id",
          "date",
          "link_mission",
          "overall_impression",
          "detailed_assessment",
          "recommendation",
          "follow_instruction",
          "visible_by",
          "overall_impression",
        ],
        (data) => "/users/" + data.user.id,
        "user"
      )
    },

    get_above_roles() {
      if (this.current_user.role) {
        let current_role = ROLES[this.current_user.role.toUpperCase()]
        return Object.keys(ROLES).filter((value) => ROLES[value] > current_role)
      }
      return []
    },
  },
}
</script>
